import React from 'react';
import { Hero } from '../components/Hero';
import { FeatureExplosion } from '../components/FeatureExplosion';
import { SovereignStack } from '../components/SovereignStack';
import { Testimonials } from '../components/Testimonials';
import { Impact } from '../components/Impact';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useSeoMeta } from '../hooks/useSeoMeta';
import { SEO_META } from '../data/seoMeta';
import { JsonLd } from '../components/JsonLd';

const ORG_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  name: 'HenselX',
  url: 'https://henselx.it',
  logo: 'https://henselx.it/Grafx/henselx_web_primary.png',
  description:
    'Sovereign IT agency for IT infrastructure, private AI/LLMs, web development and AI automation. 100% EU-hosted, GDPR-compliant. Based in Acri, Calabria, Italy.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Contrada Aria delle Donne 39',
    postalCode: '87041',
    addressLocality: 'Acri (CS)',
    addressCountry: 'IT',
  },
  telephone: '+393242511984',
  email: 'hello@henselx.io',
  sameAs: ['https://henselx.io', 'https://henselx.com'],
  serviceType: [
    'IT Infrastructure',
    'Private AI & Local LLMs',
    'Web Development',
    'App Development',
    'AI Automation',
  ],
};

export const Home: React.FC = () => {
  useSeoMeta({ meta: SEO_META.home, canonicalPath: '/' });

  return (
    <div className="bg-white dark:bg-[#000000] transition-colors duration-300">
      <JsonLd data={ORG_SCHEMA} id="jsonld-organization" />
      <Hero />
      <FeatureExplosion />
      <SovereignStack />
      <Testimonials />
      <Impact />

      {/* Pre-Footer CTA */}
      <section className="relative py-32 px-6 overflow-hidden bg-slate-50 dark:bg-[#000000]">
        <div className="absolute inset-0 hx-grid-bg" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-[#0ea5e9]/8 rounded-full blur-[140px] pointer-events-none" />
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <span className="hx-badge mb-6 inline-block">KONTAKT</span>
          <h2 className="text-5xl md:text-6xl font-black tracking-tight text-slate-900 dark:text-white mb-6 leading-none">
            Bereit für das<br /><span className="text-[#0ea5e9]">Upgrade</span>?
          </h2>
          <p className="text-slate-600 dark:text-slate-400 mb-10 text-lg max-w-xl mx-auto leading-relaxed">
            Lassen Sie uns Ihre IT-Infrastruktur zukunftssicher machen.
            Verbinden Sie lokale Sicherheit mit globaler Performance — ohne US-Clouds.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-3 h-14 px-10 rounded-sm bg-[#0ea5e9] text-black font-bold text-sm tracking-wide hover:bg-slate-900 hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors duration-200"
          >
            Kostenloses Erstgespräch
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
};
